/** Clinical context category for the narrative note */
export enum NarrativeCategory {
  GENERAL = 'general',
  PROCEDURE = 'procedure',
  CONSENT = 'consent',
  EMERGENCY = 'emergency',
  /** Family communication */
  FAMILY_COMM = 'family-comm',
}

export interface Narrative {
  /** Unix timestamp (ms) of when the event occurred (not when it was typed) */
  timestamp: number
  /** Free-text content of the note */
  noteBody: string
  /** Clinical category of the note */
  category: NarrativeCategory
  /** Optional tags for the note (e.g. "position_change", "hydrotherapy") */
  tags: string[]
  /** True if this note has been amended */
  isAmended: boolean
  /** UUID of the original note if this is an amendment */
  parentNoteId?: string
}
